import { Box, Collapse, IconButton, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { StationParameterWarningItem } from "../../../models/types/stationParameterWarnings";
import { useLookupParameter } from "../../../utils/get-lookup";
import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";
import { useResponsive } from "../../../hooks/mediaQuery";

const ParameterWarnings = ({ data, editUrl, defaultOpen }: { data: StationParameterWarningItem[]; editUrl: string; defaultOpen?: boolean }) => {
    const { lookupParameter } = useLookupParameter();
    const [open, setOpen] = useState<boolean>(defaultOpen || false);
    const { isXs } = useResponsive();

    return (
        <div className="bg-white rounded-md">
            <Box sx={{ borderRadius: 1, border: "1px solid #cce4ff" }}>
                <Box
                    className="summary_header"
                    sx={{
                        backgroundColor: "#e3f2fd",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                    }}
                    onClick={() => setOpen(!open)}
                >
                    <Typography fontWeight="bold">Ngưỡng cảnh báo</Typography>
                    <div className="flex items-center gap-2">
                        <Link
                            to={editUrl}
                            className="flex items-center gap-1 italic text-blue-500 text-sm hover:underline"
                        >
                            <Pencil size={12} />
                            Sửa
                        </Link>
                        <IconButton size="small">
                            <ExpandMoreIcon
                                sx={{
                                    transform: open ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.2s",
                                }}
                            />
                        </IconButton>
                    </div>
                </Box>
                <Collapse in={open}>
                    <Box className="summary_content w-full" sx={{ p: isXs ? 1 : 2 }}>
                        <table className="w-full text-left text-gray-700 border border-gray-200 shadow-md">
                            <thead className="bg-gray-200 font-semibold text-gray-600">
                                <tr>
                                    <th className={`${isXs ? "px-2 py-2 " : "px-4 py-3 "} text-left`}>STT</th>
                                    <th className={`${isXs ? "px-2 py-2 " : "px-4 py-3 "} text-left`}>Mã</th>
                                    <th className={`${isXs ? "px-2 py-2 " : "px-4 py-3 "} text-left`}>Thông số</th>
                                    <th className={`${isXs ? "px-2 py-2 " : "px-4 py-3 "} text-left`}>Đơn vị</th>
                                    <th className={`${isXs ? "px-2 py-2 " : "px-4 py-3 "} text-left`}>Giá trị min</th>
                                    <th className={`${isXs ? "px-2 py-2 " : "px-4 py-3 "} text-left`}>Giá trị max</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => {
                                    const parameter = lookupParameter.find((p) => p.id === item.parameterId);
                                    return (
                                        <tr key={index} className={`hover:bg-gray-100 ${index % 2 === 1 ? "bg-gray-50" : ""}`}>
                                            <td className="px-4 py-2 text-left">{index + 1}</td>
                                            <td className="px-4 py-2 text-left">{parameter?.code ? parameter.code : "-"}</td>
                                            <td className="px-4 py-2 text-left">{parameter?.name ? parameter.name : "-"}</td>
                                            <td className="px-4 py-2 text-left">{parameter?.unitName ? parameter.unitName : "-"}</td>
                                            <td className="px-4 py-2 text-left">{item.earlyWarningMin ? item.earlyWarningMin : 0}</td>
                                            <td className="px-4 py-2 text-left">{item.earlyWarningMax ? item.earlyWarningMax : 0}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </Box>
                </Collapse>
            </Box>
        </div>
    );
};

export default ParameterWarnings;